import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from '@atlassian/jira-relay/src/__generated__/BacklogAggAppDataQuery$parameters';

export const nextGenBacklogEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-next-gen-backlog-entrypoint" */ './src/ui/backlog/index.tsx'
			),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { context, tenantContext } = entryPointRouteParams;
		const routeName = context.route.name;

		if (
			routeName !== 'rapidboard-backlog' ||
			// Commenting out these two routes as we get an error from Relay if we try to
			// load the query on these routes. We should revisit this when we have proper
			// user testing on these routes.
			// routeName !== 'rapidboard-user-backlog' &&
			// routeName !== 'rapidboard-backlog-embed'
			!fg('backlog_relay_data_resource')
		) {
			return {};
		}

		return {
			queries: {
				backlogDataQuery: {
					parameters,
					variables: {
						boardId: `ari:cloud:jira-software:${tenantContext.cloudId}:board/${context.match.params.boardId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
